<template>
    <div class="settings-home">
        <div
            v-for="(setting, indexSetting) in settings"
            :key="indexSetting"
            class="settings-home__block"
        >
            <div class="settings-home__block-title">
                <CompassColoredIcon
                    :icon="setting.icon"
                    :color="CompassEnums.ColoredIconColorType.BRAND"
                />
                <h3 class="typographies-heading-h3">{{ setting.label }}</h3>
            </div>
            <ul class="settings-home__block-list">
                <li
                    v-for="(sub, indexSub) in setting.sub"
                    :key="indexSub"
                    class="settings-home__block-list-item"
                >
                    <router-link
                        v-if="sub.vueRouting"
                        :to="sub.url"
                        class="typographies-paragraph-medium-semibold"
                    >
                        {{ sub.label }}
                    </router-link>
                    <a v-else :href="sub.url" class="typographies-paragraph-medium-semibold">
                        {{ sub.label }}
                    </a>

                    <CompassFlag
                        v-if="sub.flag"
                        :label="sub.flag.label"
                        :size="sub.flag.size"
                        :beta="sub.flag.beta"
                        class="settings-home__flag"
                    />
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const settingsStore = createNamespacedHelpers('settingsStore');
export default {
    computed: {
        ...settingsStore.mapGetters({
            settings: 'getSettings',
        }),
    },
};
</script>

<style lang="scss" scoped>
.settings-home {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: var(--spacing-5);

    &__block {
        &-title {
            margin: 0 0 var(--spacing-2);
            display: flex;
            gap: var(--spacing-1);

            h3 {
                margin: 0;
            }
        }

        &-list {
            display: flex;
            flex-direction: column;
            gap: var(--spacing-0);
            margin: 0;

            &-item {
                display: flex;
                align-items: center;
                gap: var(--spacing-0);
            }
        }

        a {
            color: var(--colors-common-text-subtle-default);

            &:hover {
                color: var(--colors-common-text-subtle-hover);
                text-decoration: underline;
            }
        }
    }
}
</style>
